module.exports = __webpack_public_path__ + "img/trofeo.41f6847b.png";